import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavMenuItem } from 'app/main/Authenticated/Header/NavMenuItem';
import classes from 'app/main/Authenticated/Header/Header.module.scss';
import { Permission } from 'app/containers/Permissions/index.js';
import { userReducerSelector } from 'app/store/selectors/user';
import { fetchOffices } from 'app/store/reducers/offices';
const Nav = () => {
    const dispatch = useDispatch();
    const { projects } = useSelector(userReducerSelector);
    const parsedProjects = projects
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(({ name, id, thumbnailInst }) => {
        const image = thumbnailInst === null || thumbnailInst === void 0 ? void 0 : thumbnailInst.url;
        return { label: name, to: `/projects/${id}`, image };
    });
    useEffect(() => {
        dispatch(fetchOffices());
    }, []);
    return (_jsxs("nav", { className: classes.nav, children: [_jsx(NavMenuItem, { items: parsedProjects, children: "Projects" }), _jsx(Permission, { actions: ['wiki___read'], children: _jsx(NavMenuItem, { to: "/assets-wiki", children: "Wiki" }) }), _jsx(Permission, { actions: ['my tasks___read'], children: _jsx(NavMenuItem, { to: "/my-tasks", children: "My Tasks" }) }), _jsx(Permission, { actions: [
                    'human resources_organization_imputations_edit',
                    'human resources_organization_imputations_read',
                    'human resources_organization_contracts_edit persons informations',
                    'human resources_organization_contracts_edit contracts',
                    'human resources_organization_people_read',
                    'human resources_time recap__read',
                    'human resources_allotment recap__read',
                    'human resources_settings_departments_edit',
                    'human resources_settings_departments_read',
                    'human resources_settings_posts_edit',
                    'human resources_settings_posts_read',
                    'human resources_settings_collective agreement titles_edit',
                    'human resources_settings_collective agreement titles_read',
                    'human resources_settings_person attributes_edit',
                    'human resources_settings_person attributes_read',
                    'human resources_settings_contract attributes_edit',
                    'human resources_settings_contract attributes_read',
                ], operator: "or", children: _jsx(NavMenuItem, { to: "/hr", children: "Human Resources" }) }), _jsx(Permission, { actions: [], children: _jsx(NavMenuItem, { to: "/admin", children: "Admin" }) })] }));
};
export default Nav;
